/* eslint-disable @typescript-eslint/consistent-type-definitions */

import { type ReactNode } from "react";
import { RouterProvider as Provider } from "react-aria-components";
import { useNavigate, type NavigateOptions } from "react-router";
import { Toaster } from "sonner";

// TODO: Add @light-technology/components ThemeProvider

declare module "react-aria-components" {
  interface RouterConfig {
    routerOptions: NavigateOptions;
  }
}

type RouterProviderProps = { children: ReactNode };

export const ComponentsProvider = (props: RouterProviderProps) => {
  const navigate = useNavigate();
  return (
    <Provider navigate={navigate}>
      <Toaster position="top-right" />
      {props.children}
    </Provider>
  );
};
